export default __webpack_public_path__ + "a11c07472b774728bdd6751c293ced59.png";